import { render } from "./AboutGallery.vue?vue&type=template&id=1ece82db&scoped=true"
import script from "./AboutGallery.vue?vue&type=script&lang=js"
export * from "./AboutGallery.vue?vue&type=script&lang=js"

import "./AboutGallery.vue?vue&type=style&index=0&id=1ece82db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ece82db"]])

export default __exports__